export const SYNCHRONIZE_OFFERS_API = '/esales/synchronizeOffers';
